import { makeStyles } from "@fluentui/react-components";

const useElementPickerStyles = makeStyles({
    elementPickerHeader:{
        dispaly: "inline",
    }
});

export default useElementPickerStyles;